import { useDispatch, useSelector } from "react-redux";
import {createSetViewAction, createUpdateSchoolAction, createValidationAction } from "shared/state/reducer";
import { AppMode, IADPState, VerifySetUpCodePayload, VerifySetUpCodeResponse } from "../typings";
import { useIPCBridge } from "./useIPCBridge";
import { useFetchService } from "./useFetchService";
import { HEADER_ENAEP } from "../util/constants";
import { getOnlineServices,environment } from "../util/index";
const logPrefix = "[ADP Student App][SetupCodeValidationServiceHook]"
export function useCodeValidationService() {
  const dispatch = useDispatch();
  const {fetch} = useFetchService();
  const state = useSelector((state:{rootState:IADPState})=>state.rootState)
  const {sendSetupCode} = useIPCBridge();
  const clearSchoolDetails = ()=>{
    console.log(logPrefix, "clearing school details...");
    dispatch(createUpdateSchoolAction(undefined));
    dispatch(createValidationAction(undefined));
  }
  const validateCode = async (code: string,codeType: AppMode)=>{
    console.log(logPrefix,` validate ${code} code for ${state.sessionState.selectedAssessmentMode} mode`);
    dispatch(createValidationAction("Verifying"));//takes care of displaying spinner
    const payload: VerifySetUpCodePayload = {
      appAccessedFor: codeType,
      adpLaunchId: state.appState.appLaunchId as string,
      setupCode: codeType == "Assess" ? code : undefined,
      verificationCode: codeType == "Verify" ? code : undefined,
      requestDateTime: new Date().toISOString(),
      deviceId: state?.deviceState?.deviceId? state?.deviceState?.deviceId:"NotAvailable",
    };
    
    const onlineServiceConfig = getOnlineServices(state.appState.configuration);
    //TODO implement npn mode
    const domain = onlineServiceConfig?.apiSubDomain?.includes("api") 
    ? environment.resolveApiDomain(state.appState.configuration) : environment.resolveENAEPDomain();
    let url = `${domain}/${onlineServiceConfig?.verifySetUpCode}?appName=adp&appVersion=${state.appState.appVersion}`;
    const onResponse = async (response: VerifySetUpCodeResponse) => {
      console.log(logPrefix,`setup code validation response status:`,response.status);
      clearSchoolDetails()//remove spinner
      if (!response.status) {
          sendSetupCode(code);
         console.table(response.status);
         dispatch(createUpdateSchoolAction(response));
         dispatch(createSetViewAction("DeviceValidationView"));
        }
      else {
        console.log({response})
        console.table(response.status);
        dispatch(createUpdateSchoolAction({status:response.status,errorCode:"true",setupCode:undefined}));
       } 
      }
      const response = await fetch(url,{headers:HEADER_ENAEP,method: "POST",body:JSON.stringify(payload)},undefined,[404]);
      if(response){
        const verifyResponse = response as unknown as VerifySetUpCodeResponse
        onResponse(verifyResponse)
      }
  }
 
  return {validateCode,clearSchoolDetails}
}
